import styled from "styled-components";
import Icon from "../Icons";

/** Down chevron that turns up while `data-active` is true */
export const Chevron = styled(Icon).attrs((props) => ({
    icon: props.icon ?? "chevron",
    size: props.size ?? "medium",
}))`
    transform: rotate(0deg);
    transition: transform 0.2s cubic-bezier(0.39, 0.575, 0.565, 1);
    &[data-active='true'] {
        transform: rotate(180deg);
    }
`;
